import { cn } from '@commenda/utils';
import { ReactNode } from 'react';

interface TimelineRailProps {
  indicator: ReactNode;
  isFirst?: boolean;
  isLast?: boolean;
  className?: string;
  indicatorAlignment?: 'center' | 'first-line';
}

/**
 * Vertical connector column for a single item in a chronological list: a caller
 * supplied indicator with connector segments above and below it. The bottom
 * segment stretches, so the rail only draws a continuous line when its parent
 * stretches it to the item's full height.
 *
 * `indicatorAlignment` of `first-line` centres the indicator on the item's
 * first line of text rather than on the column, which assumes a `txt-small`
 * heading.
 */
export const TimelineRail = ({
  indicator,
  isFirst = false,
  isLast = false,
  className,
  indicatorAlignment = 'center',
}: TimelineRailProps) => (
  <div
    className={cn(
      'flex flex-col items-center',
      indicatorAlignment === 'first-line' ? 'gap-none' : 'gap-1.5',
      className
    )}
  >
    <div
      className={cn(
        indicatorAlignment === 'first-line' ? 'h-1.5' : 'h-3.5',
        'shrink-0',
        !isFirst && 'border-l border-border-secondary'
      )}
    />
    {indicator}
    {isLast ? (
      <div className="h-1.5 shrink-0" />
    ) : (
      <div className="flex-1 border-l border-border-secondary" />
    )}
  </div>
);
